import React, {Component} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import {Table, Tooltip, Input} from "reactstrap";
import {getCurrentMicroTime} from "reducers/timeMeasuring/actions";
import classnames from "classnames";
import Select from 'react-select';
import MobileMatrix from "../../Components/matrix/mobileMatrix";

class PresentationTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      rowTooltipOpen: false,
      columnTooltipOpen: false
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.isTooltipOpen = this.isTooltipOpen.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.getAnswerLabel = this.getAnswerLabel.bind(this);
    this.filterOptions = this.filterOptions.bind(this);
    this.onSelect = this.onSelect.bind(this)
    this.canGoToNextRow = this.canGoToNextRow.bind(this);
    this.columnCountRequirements = this.columnCountRequirements.bind(this);
    this.rowCountRequirements = this.rowCountRequirements.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const matrixDropdownTableHeadRow = document.getElementById('matrixDropdownTableHeadRow-' + this.props.question.id);
    const matrixDropdownTable = document.getElementById('matrixDropdownTable-' + this.props.question.id);
    const shouldBeSticky = matrixDropdownTable.offsetHeight > window.innerHeight;

    _.each(matrixDropdownTableHeadRow.children, column => {
      if (shouldBeSticky && !column.classList.contains('sticky-top')) {
        column.classList.add('sticky-top')
      }
      if (shouldBeSticky && !column.classList.contains('top-0')) {
        column.classList.add('top-0')
      }
    })
  }

  toggleTooltip(value, type) {
    if (this.state[type] === value) {
      this.setState({[type]: false});
    }else{
      this.setState({[type]: value});
    }
  }

  isTooltipOpen(value, type) {
    return this.state[type] === value;
  }

  onSelect(rowId, columnId, answerId) {
    let {question, details} = this.props;

    const microTime = getCurrentMicroTime(this.props.startTime);

    if (question.transposed) {
      if (!details.find(detail => (detail.column === rowId) && (detail.row === columnId))) {
        this.props.onDetailsUpdated([...details, {column: rowId, row: columnId, answer: answerId, microTime}]);
      } else {
        let detailsUpdated = details.map(detail => {
          if(detail.column === rowId && detail.row === columnId){
            return {column: rowId, row: columnId, answer: answerId, microTime};
          }

          return detail;
        });
        this.props.onDetailsUpdated(detailsUpdated);
      }
    } else {
      if (!details.find(detail => (detail.row === rowId) && (detail.column === columnId))) {
        this.props.onDetailsUpdated([...details, {row: rowId, column: columnId, answer: answerId, microTime}]);
      } else {
        let detailsUpdated = details.map(detail => {
          if(detail.row === rowId && detail.column === columnId){
            return {row: rowId, column: columnId, answer: answerId, microTime};
          }

          return detail;
        });
        this.props.onDetailsUpdated(detailsUpdated);
      }
    }
  }

  canGoToNextRow(currentRow) {
    const {question, details, contentRow, contentColumn} = this.props;
    const transposed = question.transposed;
    const row = transposed ? question.columns[currentRow] : question.rows[currentRow];
    const requiredMinRows = transposed ? (question.requiredAllDropdowns ? question.columns.length : question.requiredColumns) : (question.requiredAllDropdowns ? question.rows.length : question.requiredRows);
    const detail = details.find(detail => {
      if (transposed) {
        return detail.column === row.id
      } else {
        return detail.row === row.id
      }
    });

    const filteredDetail = details.filter(detail => {
      if (transposed) {
        return detail.column === row.id
      } else {
        return detail.row === row.id
      }
    });

    const currentRowObject = question.rows[currentRow]
    const rowContent = currentRowObject ? contentRow[currentRowObject.id] : "";

    if (row && row.excludeRequired) {
      return true;
    }

    if (requiredMinRows && filteredDetail.length < requiredMinRows) {
      return false;
    }

    if (currentRowObject && currentRowObject.isOpen && currentRowObject.openIsRequired && !rowContent && ((detail && detail.row === currentRowObject.id))) {
      return false;
    }

    if (!requiredMinRows) {
      return true;
    }

    return detail
  }

  getAnswerLabel(answer) {
    return this.props.question.answersImage
      ? <span className="img-30"><img src={answer.content} /></span>
      : <span className="img-20" dangerouslySetInnerHTML={{__html: answer.content}}/>
  }

  filterOptions(option, searchText) {
    const content = this.props.question.answers.find(answer => answer.id === option.value).content;
    return String(option.value).includes(searchText) || content.toLowerCase().includes(searchText.toLowerCase());
  }

  columnCountRequirements(column) {
    const {question, details} = this.props;
    let columnMin = question.transposed ? (question.requiredRows ? 1 : 0) : (question.requiredColumns ? 1 : 0);
    if (question.requiredAllDropdowns) {
      columnMin = question.transposed ? question.rows.length : question.columns.length;
    }

    if (column.blocking && columnMin === 0) {
      columnMin = 1;
    }

    if (column.excludeRequired) {
      return false;
    }

    if (columnMin) {
      if (question.transposed) {
        if (details.filter(detail => detail.row === column.id).length < columnMin) {
          return true;
        }
      } else {
        if (details.filter(detail => detail.column === column.id).length < columnMin) {
          return true;
        }
      }
    }

    return false;
  }

  rowCountRequirements(row) {
    const {question, details, contentRow, contentColumn} = this.props;
    let rowsMin = question.transposed ? (question.requiredColumns ? 1 : 0) : (question.requiredRows ? 1 : 0);
    if (question.requiredAllDropdowns) {
      rowsMin = question.transposed ? question.columns.length : question.rows.length;
    }

    if (row.blocking === 0 && rowsMin === 0) {
      rowsMin = 1;
    }

    if (row.excludeRequired) {
      return false;
    }

    if (rowsMin) {
      if (question.transposed) {
        if (details.filter(detail => detail.column === row.id).length < rowsMin) {
          return true;
        }
      } else {
        if (details.filter(detail => detail.row === row.id).length < rowsMin) {
          return true;
        }
      }
    }

    return false;
  }

  render() {
    const {question, details, contentRow, contentColumn, validated, validationTexts, questionResponse} = this.props;
    let style = {};

    if(question.labelsWhiteSpaceNoWrap){
      style.whiteSpace = 'nowrap';
    }

    const answersOptions = _.map(question.answers, answer => {
      return {label: this.getAnswerLabel(answer), value: answer.id}
    });

    const transposed = question.transposed;
    
    const rows = transposed ? question.columns : question.rows;
    const columns = transposed ? question.rows : question.columns;
    const rowsImage = transposed ? question.columnsImage : question.rowsImage;
    const columnsImage = transposed ? question.rowsImage : question.columnsImage;
    let isColumnError = false;
    _.map(columns, (column, index) => {
      if (this.columnCountRequirements(column)) {
        isColumnError = true;
      }
    });

    return (
      <React.Fragment>
        <MobileMatrix
          question={question}
          contentRow={contentRow}
          contentColumn={contentColumn}
          onChangeContentColumn={this.props.onChangeContentColumn}
          onChangeContentRow={this.props.onChangeContentRow}
          onSelect={this.onSelect}
            validationTexts={validationTexts}
          getAnswerLabel={this.getAnswerLabel}
          canGoToNextRow={this.canGoToNextRow}
          onItemClick={() => {}}
          isColumnError={isColumnError && !questionResponse.excluding}
          details={details}
          validated={validated}
            questionResponse={questionResponse}
        />
        <Table id={"matrixDropdownTable-" + question.id} className="d-none d-md-table" bordered>
          <thead>
            <tr id={"matrixDropdownTableHeadRow-" + question.id}>
              <th style={{
                width: question.firstColumnWidth + '%'
              }}/>
              {_.map(columns, column => {
                const columnContent = transposed ? contentRow[column.id] : contentColumn[column.id];

                return <th
                    key={column.id}
                    className={classnames({
                      "text-center": true
                    })}
                    style={{
                      width: question.equalColumns ? parseInt((100 - question.firstColumnWidth) / columns.length) + '%' : 'auto',
                    }}
                >
                  {columnsImage ?
                      <div key={column.id} data-id={column.id}>
                        <img id={`tooltip-column-${column.id}`} src={column.content}/>
                        <Tooltip
                            delay={0}
                            placement="top"
                            isOpen={this.isTooltipOpen(column.id, 'columnTooltipOpen')}
                            target={`tooltip-column-${column.id}`}
                            toggle={() => this.toggleTooltip(column.id, 'columnTooltipOpen')}
                        >
                          {column.description}
                        </Tooltip>
                      </div> : <span dangerouslySetInnerHTML={{__html: column.content}}/>}

                  {column.isOpen && <Input
                      placeholder={this.props.intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})}
                      onChange={(e) => {
                        if (transposed) {
                          this.props.onChangeContentRow(column.id, e.target.value)
                        } else {
                          this.props.onChangeContentColumn(column.id, e.target.value)
                        }
                      }}
                      value={columnContent}
                  />}
                </th>
              })}
            </tr>
          </thead>
          <tbody>
          {_.map(rows, row => {
            const rowContent = transposed ? contentColumn[row.id] : contentRow[row.id];

            return <tr
                key={row.id} className={classnames({
            })}
            >
              <td className="align-middle first-column" style={style}>
                {rowsImage ?
                    <div key={row.id} data-id={row.id}>
                      <img id={`tooltip-row-${row.id}`} src={row.content}/>
                      <Tooltip
                          delay={0}
                          placement="top"
                          isOpen={this.isTooltipOpen(row.id, 'rowTooltipOpen')}
                          target={`tooltip-row-${row.id}`}
                          toggle={() => this.toggleTooltip(row.id, 'rowTooltipOpen')}
                      >
                        {row.description}
                      </Tooltip>
                    </div> : <span dangerouslySetInnerHTML={{__html: row.content}}/>}

                {row.isOpen && <Input
                    placeholder={this.props.intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})}
                    onChange={(e) => {
                      if (transposed) {
                        this.props.onChangeContentColumn(row.id, e.target.value)
                      } else {
                        this.props.onChangeContentRow(row.id, e.target.value)
                      }
                    }}
                    value={rowContent}
                />}
              </td>
              {_.map(columns, column => {
                const checked = transposed ? details.find(detail => detail.column === row.id && detail.row === column.id)
                    : details.find(detail => detail.row === row.id && detail.column === column.id);

                return <td
                    className={classnames({
                      'align-middle pointer dropdown-container': true,
                      'selected': checked,
                      'cafetery-error': validated  && !questionResponse.excluding && !checked && (
                          (this.columnCountRequirements(column) || this.rowCountRequirements(row))
                      ),
                    })}
                    key={column.id}
                >
                  <Select
                      menuPlacement={"bottom"}
                      maxMenuHeight={408}
                      class={"dropdown-wrapper"}
                      isMulti={false}
                      value={checked ? {
                        value: checked.answer,
                        label: this.getAnswerLabel(question.answers.find(answer => answer.id === checked.answer))
                      } : null}
                      onChange={e => this.onSelect(row.id, column.id, e.value)}
                      options={answersOptions}
                      placeholder={this.props.intl.formatMessage({id: 'question.dropdown.open'})}
                      menuPosition="fixed"
                      inputProps={{readOnly:true}}
                      isSearchable={false}
                      styles={{menu: (provided) => ({...provided, width: 'max-content'})}}
                      filterOption={this.filterOptions}
                  />
                </td>
              })}
            </tr>
          })}
          </tbody>
        </Table>
      </React.Fragment>
    );
  }
}

PresentationTable.propTypes = {
  question: PropTypes.shape({
    equalColumns: PropTypes.bool.isRequired,
    labelsWhiteSpaceNoWrap: PropTypes.bool.isRequired,
    firstColumnWidth: PropTypes.number.isRequired,
  }).isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  onChangeContentColumn: PropTypes.func.isRequired,
  onChangeContentRow: PropTypes.func.isRequired,
  isAnswerDisabled: PropTypes.func.isRequired,
  contentRow: PropTypes.object,
  contentColumn: PropTypes.object,
  validated: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true})(PresentationTable);